const PREFIX = 'INSTITUTIONAL_DATA';

const constants = {
  FETCH_DATA_SETS: `${PREFIX}/FETCH_DATA_SETS`,
  RECEIVE_DATA_SETS_DONE: `${PREFIX}/RECEIVE_DATA_SETS_DONE`,
  RECEIVE_DATA_SETS_ERROR: `${PREFIX}/RECEIVE_DATA_SETS_ERROR`,
};

export default constants;
